import {Box, Button} from '@chakra-ui/react';
import {TransactionDrawerHeader} from './transaction-drawer-header';
import {TransactionDrawerFooter} from './transaction-drawer-footer';
import {useTransactionDrawerContext} from '../../../context/transaction-drawer';

interface TransactionDrawerSessionExpiredProps {
  isActive?: boolean;
  onReturnClick: () => void;
  title: string;
  details: string;
  ctaLabel: string;
}

export const TransactionDrawerSessionExpired: React.FC<
  TransactionDrawerSessionExpiredProps
> = ({isActive = false, onReturnClick, title, details, ctaLabel}) => {
  const {resetDrawer} = useTransactionDrawerContext();

  return (
    <>
      {isActive && (
        <Box
          pos="absolute"
          zIndex={10}
          top={0}
          left={0}
          width="100%"
          height="100%"
          background="white"
          paddingTop={{base: '32px', md: '80px'}}
          paddingX={{base: '32px', md: '48px'}}
        >
          <TransactionDrawerHeader title={title} intro={details} />
          <TransactionDrawerFooter variation="no-shadow">
            <Button
              colorScheme="aqua"
              height="56px"
              display="block"
              width="100%"
              mb={4}
              onClick={() => onReturnClick && onReturnClick()}
            >
              {ctaLabel}
            </Button>
            <Button
              colorScheme="aqua"
              height="56px"
              width="100%"
              variant="outline"
              onClick={() => resetDrawer && resetDrawer()}
            >
              Exit
            </Button>
          </TransactionDrawerFooter>
        </Box>
      )}
    </>
  );
};
